// Helpers for sending CTAs to the self-schedule app at /schedule.
//
// /schedule is NOT a Gatsby route — it is a Netlify reverse proxy to the
// self-schedule app on Vercel (WEBDEV-4338, see the root netlify.toml). A
// Gatsby <Link> or navigate() would attempt a client-side route change and
// 404, so every navigation here is a full page load.
//
// The proxy is also what makes the sessionStorage handoff possible at all:
// it puts the app on the metro's own origin, and sessionStorage is per-origin.

// Build the self-schedule URL with the full current page URL (query params and
// all) URI-encoded into returnUrl, so the app can send the visitor back to the
// metro page they came from.
// e.g. /schedule?returnUrl=https%3A%2F%2Fmilanlaserphilly.com%2F
//
// entry: an optional signal for how the visitor arrived ('onpage' for the
// handoff flow — see selfScheduleHandoff.js). The app treats entry=onpage as a
// required precondition before it will look for a payload; the authoritative
// data lives in sessionStorage, not in the URL.
export function getSelfScheduleUrl({ entry } = {}) {
    if (typeof window === 'undefined') return '/schedule';
    const returnUrl = `returnUrl=${encodeURIComponent(window.location.href)}`;
    const entryParam = entry ? `&entry=${encodeURIComponent(entry)}` : '';
    return `/schedule?${returnUrl}${entryParam}`;
}

export function goToSelfSchedule(newTab = false) {
    if (typeof window === 'undefined') return;
    const url = getSelfScheduleUrl();
    // New tab must use window.open (within the click gesture); same-tab uses
    // location.assign — clearer than window.open('_self') and avoids webview
    // quirks. assign keeps a history entry so Back returns here.
    if (newTab) {
        window.open(url, '_blank');
    } else {
        window.location.assign(url);
    }
}

// Navigates into the on-page handoff flow. Always same-tab: this is called from
// a form submit, not from a click gesture that could carry new-tab intent.
export function goToSelfScheduleOnPage() {
    if (typeof window === 'undefined') return;
    window.location.assign(getSelfScheduleUrl({ entry: 'onpage' }));
}
